import CalendarLocale from '../../vc-calendar/src/locale/ca_ES'
import TimePickerLocale from '../../time-picker/locale/ca_ES'

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'Seleccionar data',
    rangePlaceholder: [
      'Data inicial', 'Data final',
    ],
    ...CalendarLocale,
  },
  timePickerLocale: {
    ...TimePickerLocale,
  },
}

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/l
// o cale/example.json

export default locale



// WEBPACK FOOTER //
// ./components/date-picker/locale/ca_ES.js